<script>
    
    import jQuery from "jquery";
    import {getCookie} from "./gppy-misc";

    let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

    let email = null;
    let password = null;

    let registerInProgress = false;

    let termsAccepted = true;
    let termsMarketingAllowed = lang === "en";

    /**
     *
     * @type {"login"|"register"|"start"}
     */
    let mode = "start";

    // reset states on changes
    $: if (email) mode = "start";
    $: if (mode === "login" || mode === "register") {
        password = null;
        serverErrors = [];
    }

    $: validEmail = !email || email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    $: validPassword = mode !== "register" || !password || password.length > 3

    $: valid = (mode === "start" && validEmail && email) ||
               (mode === "login" && validEmail && password) ||
               (mode === "register" && validEmail && validPassword && termsAccepted && password)

    $: displayErrors = (mode === "login" && !(serverErrors.length === 0)) ||
        (mode === "register" && !(valid && serverErrors.length === 0))

    $: invalidEmailErr = validEmail ? "" : t("Incorrect email.")
    $: invalidPasswordErr = validPassword ? "" : t("Password must have at least 4 characters.")
    $: invalidTermsErr = termsAccepted ? "" : t("To proceed terms must be accepted.")

    let serverErrors = [];

    $: form_errors = !displayErrors ? [] : [...serverErrors, invalidEmailErr, invalidPasswordErr, invalidTermsErr].filter(e => e.length)

    $: if (mode) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'try_demo_view',
            'step': mode
        })
    }

    export let nextAction = null;

    let i18 = {
        "pl": {
            "Your email:": "Twój email:",
            "Preparing your trial...": "Przygotowujemy dostęp demo...",
            "Of course, you want to try GardenPuzzle before buying! We’re giving you free access so you can explore its features. In the demo, you can work with sample backgrounds—adding your own garden photo is available in the full version. Sounds fair?":"Jasne, że chcesz wypróbować GardenPuzzle przed zakupem! Damy Ci darmowy dostęp, byś poznał możliwości programu. W demo możesz pracować na przykładowych tłach – zdjęcie własnego ogrodu dodasz w płatnej wersji. Brzmi fair?",
            "It seems that you already have an account at GardenPuzzle. Enter password to log in:" : "Wygląda na to, że masz już konto w serwisie GardenPuzzle. Podaj hasło aby się zalogować:",
            "Password:": "Hasło:",
            "Choose password:": "Wybierz hasło:",
            "I&nbsp;accept": "Akceptuję",
            "terms.": "regulamin.",
            "Send me occasional updates about special offers, new products etc.": "Chcę otrzymywać okazjonalne maile o aktualizacjach produktów i specjalnych ofertach",
            "Password must have at least 4 characters.": "Hasło musi mieć przynajmniej 4 znaki.",
            "To proceed terms must be accepted.": "Wymagane jest zaakceptowanie regulaminu.",
            "Incorrect email.": "Niepoprawny email."
        }
    }

    function t(message) {
        if (lang === "en") return message;
        if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
    }

    export function showRegisterForm () {
        jQuery('#registerForm').modal();
        jQuery('#registerForm').on('hidden.bs.modal', () => this.$destroy());
        jQuery('#registerForm').on('shown.bs.modal',function (){jQuery('#registerFormEmail').focus();});
    }
    
    function confirm () {
        if (!valid || registerInProgress) return;

        registerInProgress = true;

        if (mode === "start") {
            Promise.resolve(jQuery.get('/fmg/emailExists', {'email': email})).then(emailChecked);
            return;
        }

        if (mode === "login") {
            let formData = new FormData();
            formData.append('login', email);
            formData.append('password', password);
            fetch('/accounts/login/', {
                method : 'POST',
                headers: {
                    'Accept': 'application/json',
                    "X-CSRFToken": getCookie("csrftoken")
                },
                body: formData}).
                then(async (response) => {
                    if (response.ok) return response.json();
                    else throw await response.json()}).
                then(final).
                catch(showServerErrors)
            return;
        }

        if (mode === "register") {
            let formData = new FormData();
            formData.append('email', email);
            formData.append('password1', password);
            formData.append('marketing', termsMarketingAllowed);
            fetch('/accounts/signup/', {
                method : 'POST',
                headers: {
                    'Accept': 'application/json',
                    "X-CSRFToken": getCookie("csrftoken")
                },
                body: formData}).
                then(async (response) => {
                    if (response.ok) return response.json();
                    else throw await response.json()}).
                then(final).
                catch(showServerErrors)
           }
    }

    function showServerErrors(res) {
        registerInProgress = false;

        let errs = res.form.errors;
        let fieldErrs = Object.values(res.form.fields).map(a => a.errors).flat()

        serverErrors = [...errs, ...fieldErrs];
    }

    function emailChecked(res) {
        registerInProgress = false;
        if (res.userExists)
            mode = "login";
        else
            mode = "register";
    }

    function final() {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'try_demo_view',
            'step': "completed"
        })
        if (nextAction) nextAction();
    }


</script>

<div id="registerForm" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title">{@html t("Preparing your trial...")}</h4>
        <div class="form-group registerFormText1">
            <span class="help-block">
                {@html t("Of course, you want to try GardenPuzzle before buying! We’re giving you free access so you can explore its features. In the demo, you can work with sample backgrounds—adding your own garden photo is available in the full version. Sounds fair?")}
            </span>
            <img src="/static/web/img/ribbon-short.jpg"/>
        </div>
      </div>
      <div class="modal-body registerFormEmail">
        <form class="form-group" on:submit|preventDefault={confirm}>
            <label for="registerFormEmail">{@html t("Your email:")}</label>
            <input id="registerFormEmail" type="email" name="email" bind:value={email}/>
        </form>

        {#if mode==="login"}
            <div class="form-group registerFormText2">
                <span class="help-block">{@html t("It seems that you already have an account at GardenPuzzle. Enter password to log in:")}</span>
            </div>
            <form class="form-group registerFormPass" on:submit|preventDefault={confirm}>
                <label for="registerFormPass">{@html t("Password:")}</label>
                <input id="registerFormPass" type="password" name="password" bind:value={password}/>
            </form>
        {/if}
        {#if mode==="register"}
            <div class="form-group registerFormPass">
                <label for="registerFormPass">{@html t("Choose password:")}</label>
                <input id="registerFormPass" type="password" name="password" bind:value={password}/>
            </div>
        {/if}
        {#if displayErrors}
            <div class="form-group registerFormAllErrors has-error">
                {#each form_errors as err}
                    <span class="help-block">{@html err}</span>
                {/each}
            </div>
        {/if}
      </div>
      <div class="modal-footer">
        {#if mode==="register"}
            <div class="form-group checkbox registerFormTerms">
                <label>
                  <input id="registerFormTerms" type="checkbox" bind:checked={termsAccepted}> {@html t("I&nbsp;accept")} <a target="_blank" href="{lang==='pl'?'/pl':''}/legal">{@html t("terms.")}</a>
                </label>
                <label>
                  <input id="registerFormMarketing" type="checkbox"
                                   bind:checked={termsMarketingAllowed}> {t("Send me occasional updates about special offers, new products etc.")}
                </label>
            </div>
        {/if}
        <a role="button" class="btn btn-primary" class:disabled={!valid || registerInProgress} on:click={confirm}>OK</a>

      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->